import * as React from 'react';

import { IRangeInputProps, RangeInput as RangeInputComponent } from '../../../RangeInput';
import * as styles from './RangeInput.css';

export const RangeInput: React.FC<IRangeInputProps> = props => {
  return (
    <div className={styles['container']}>
      <RangeInputComponent {...props} />
    </div>
  );
};
